import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class Column extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get content() {
    return get(this, '_content', {});
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Column.model.js